import { c as _c } from "react/compiler-runtime";
import { ActionLink } from "@/components/common/actions/actions.component";
import { getI18nString } from "@/lib/utils";
import type { FooterFragmentResult } from "@/lib/sanity/sanity.types";

// Extract menu item type from FooterFragmentResult
type FooterData = NonNullable<FooterFragmentResult>;
type FooterMenuData = NonNullable<FooterData["menus"]>[number];
type FooterMenuItem = NonNullable<NonNullable<FooterMenuData>["items"]>[number];
interface FooterMenuProps {
  heading: string | null;
  items: FooterMenuItem[] | null;
}

/**
 * Footer menu column component.
 * Renders a heading with a list of navigation links.
 * Relies on parent `dark` class for semantic token resolution.
 */
export function FooterMenu(t0) {
  const $ = _c(7);
  const {
    heading,
    items
  } = t0;
  let t1;
  if ($[0] !== heading) {
    t1 = heading && <h3 className="typography-mobile-heading-overline tablet:typography-component-xs-regular mb-5 text-text-secondary">{heading}</h3>;
    $[0] = heading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items) {
    t2 = items && items.length > 0 && <ul className="space-y-2">{items.map(_temp)}</ul>;
    $[2] = items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(item) {
  return item?.to ? <li key={item._id}><ActionLink actionTo={item.to} className="typography-component-md-sm text-text-primary pt-1 border-b border-transparent transition-colors hover:border-current">{getI18nString(item.text, "Link")}</ActionLink></li> : null;
}